function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M11.88,0A11.87,11.87,0,1,0,23.75,11.88,11.89,11.89,0,0,0,11.88,0ZM4.32,20a29.54,29.54,0,0,1,4.17-1.74L10,17.73a.39.39,0,0,0,.24-.35v-2.5a.38.38,0,0,0-.25-.36c-.05,0-1.25-.47-1.25-2.64a.38.38,0,0,0-.37-.38c-.12,0-.25-.27-.25-.62s.13-.63.25-.63a.38.38,0,0,0,.37-.37,2.14,2.14,0,0,0-.11-.52c-.16-.56-.58-2-.15-2.5.14-.16.42-.2.81-.12a.38.38,0,0,0,.44-.27c.18-.71,1.39-1.22,2.88-1.22s2.71.51,2.89,1.22a6,6,0,0,1-.37,2.86,1.84,1.84,0,0,0-.14.55.38.38,0,0,0,.38.37c.11,0,.24.27.24.63s-.13.62-.24.62a.38.38,0,0,0-.38.38c0,2.17-1.2,2.62-1.24,2.64a.37.37,0,0,0-.26.36v2.5a.39.39,0,0,0,.24.35l1.62.59A28.28,28.28,0,0,1,19.45,20,11.08,11.08,0,0,1,4.32,20ZM20,19.47a26.63,26.63,0,0,0-4.4-1.86c-.45-.16-.9-.32-1.36-.5v-2a3.29,3.29,0,0,0,1.49-2.94,1.38,1.38,0,0,0,.63-1.29,1.44,1.44,0,0,0-.54-1.25.25.25,0,0,1,0-.07,6.38,6.38,0,0,0,.39-3.28C15.91,5,14.09,4.5,12.62,4.5S9.65,4.89,9.13,6a1.39,1.39,0,0,0-1.19.39c-.71.77-.27,2.36,0,3.22l0,0a1.43,1.43,0,0,0-.55,1.26A1.36,1.36,0,0,0,8,12.17,3.29,3.29,0,0,0,9.5,15.11v2l-1.27.46a26.77,26.77,0,0,0-4.47,1.9,11,11,0,0,1-3-7.6A11.13,11.13,0,1,1,20,19.47Z"
})));

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23.75 23.75",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.1bf3f47a.svg";
export { ForwardRef as ReactComponent };